module.exports = {"540223100":"协格尔镇","540223101":"岗嘎镇","540223200":"扎西宗乡","540223201":"绒辖乡","540223202":"曲当乡","540223203":"措果乡","540223204":"曲洛乡","540223205":"长所乡","540223206":"尼辖乡","540223207":"扎果乡","540223208":"克玛乡","540223209":"盆吉乡","540223210":"加措乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540223.json
// module id = 2826
// module chunks = 0